import { BusinessType } from 'types'

const CDN = 'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto,c_fill,w_1280,h_900'

const FALLBACK_BEFORE = `${CDN}/onboarding_assets/thumbnail_wxes65.png`

export const BEFORE_IMAGES: Partial<Record<BusinessType, string>> = {
  product: `${CDN}/onboarding_assets/visual_styles_examples/product_before.jpg`,
  place: `${CDN}/onboarding_assets/visual_styles_examples/place_before.jpg`,
  service: `${CDN}/onboarding_assets/visual_styles_examples/service_before.jpg`,
}

// im listing these as human readable instead of the VS id just for my sanity
export const AFTER_IMAGES: Partial<Record<string, Partial<Record<BusinessType, string>>>> = {
  'hero shot': {
    product: `${CDN}/onboarding_assets/visual_styles_examples/product_hero_shot.jpg`,
    place: `${CDN}/onboarding_assets/visual_styles_examples/place_hero_shot.jpg`,
    service: `${CDN}/onboarding_assets/visual_styles_examples/service_hero_shot.jpg`,
  },
  'disposable camera': {
    product: `${CDN}/onboarding_assets/visual_styles_examples/product_disposable_camera.jpg`,
    place: `${CDN}/onboarding_assets/visual_styles_examples/place_disposable_camera.jpg`,
    service: `${CDN}/onboarding_assets/visual_styles_examples/service_disposable_camera.jpg`,
  },
  'negative edge': {
    product: `${CDN}/onboarding_assets/visual_styles_examples/product_negative_edge.jpg`,
    place: `${CDN}/onboarding_assets/visual_styles_examples/place_negative_edge.jpg`,
    service: `${CDN}/onboarding_assets/visual_styles_examples/service_negative_edge.jpg`,
  },
  'amber shadow': {
    product: `${CDN}/onboarding_assets/visual_styles_examples/product_amber_shadow.jpg`,
    place: `${CDN}/onboarding_assets/visual_styles_examples/place_amber_shadow.jpg`,
    service: `${CDN}/onboarding_assets/visual_styles_examples/service_amber_shadow.jpg`,
  },
  'retro frame': {
    product: `${CDN}/onboarding_assets/visual_styles_examples/product_retro_frame.jpg`,
    place: `${CDN}/onboarding_assets/visual_styles_examples/place_retro_frame.jpg`,
    service: `${CDN}/onboarding_assets/visual_styles_examples/service_retro_frame.jpg`,
  },
  'saturated film': {
    product: `${CDN}/onboarding_assets/visual_styles_examples/product_saturated_film.jpg`,
    place: `${CDN}/onboarding_assets/visual_styles_examples/place_saturated_film.jpg`,
    service: `${CDN}/onboarding_assets/visual_styles_examples/service_saturated_film.jpg`,
  },
  'indigo dusk': {
    product: `${CDN}/onboarding_assets/visual_styles_examples/product_indigo_dusk.jpg`,
    place: `${CDN}/onboarding_assets/visual_styles_examples/place_indigo_dusk.jpg`,
    service: `${CDN}/onboarding_assets/visual_styles_examples/service_indigo_dusk.jpg`,
  },
  'electric pulse': {
    product: `${CDN}/onboarding_assets/visual_styles_examples/product_electric_pulse.jpg`,
    place: `${CDN}/onboarding_assets/visual_styles_examples/place_electric_pulse.jpg`,
    service: `${CDN}/onboarding_assets/visual_styles_examples/service_electric_pulse.jpg`,
  },
  'sun-drenched': {
    product: `${CDN}/onboarding_assets/visual_styles_examples/product_sun_drenched.jpg`,
    place: `${CDN}/onboarding_assets/visual_styles_examples/place_sun_drenched.jpg`,
    service: `${CDN}/onboarding_assets/visual_styles_examples/service_sun_drenched.jpg`,
  },
  'golden hour': {
    product: `${CDN}/onboarding_assets/visual_styles_examples/product_golden_hour.jpg`,
    place: `${CDN}/onboarding_assets/visual_styles_examples/place_golden_hour.jpg`,
    service: `${CDN}/onboarding_assets/visual_styles_examples/service_golden_hour.jpg`,
  },
  'classic mono': {
    product: `${CDN}/onboarding_assets/visual_styles_examples/product_classic_mono.jpg`,
    place: `${CDN}/onboarding_assets/visual_styles_examples/place_classic_mono.jpg`,
    service: `${CDN}/onboarding_assets/visual_styles_examples/service_classic_mono.jpg`,
  },
  'executive warmth': {
    product: `${CDN}/onboarding_assets/visual_styles_examples/product_executive_warmth.jpg`,
    place: `${CDN}/onboarding_assets/visual_styles_examples/place_executive_warmth.jpg`,
    service: `${CDN}/onboarding_assets/visual_styles_examples/service_executive_warmth.jpg`,
  },
  'amber glow': {
    product: `${CDN}/onboarding_assets/visual_styles_examples/product_amber_glow.jpg`,
    place: `${CDN}/onboarding_assets/visual_styles_examples/place_amber_glow.jpg`,
    service: `${CDN}/onboarding_assets/visual_styles_examples/service_amber_glow.jpg`,
  },
  'night owl': {
    product: `${CDN}/onboarding_assets/visual_styles_examples/product_night_owl.jpg`,
    place: `${CDN}/onboarding_assets/visual_styles_examples/place_night_owl.jpg`,
    service: `${CDN}/onboarding_assets/visual_styles_examples/service_night_owl.jpg`,
  },
  'high bloom': {
    product: `${CDN}/onboarding_assets/visual_styles_examples/product_high_bloom.jpg`,
    place: `${CDN}/onboarding_assets/visual_styles_examples/place_high_bloom.jpg`,
    service: `${CDN}/onboarding_assets/visual_styles_examples/service_high_bloom.jpg`,
  },
  'day one': {
    product: `${CDN}/onboarding_assets/visual_styles_examples/product_day_one.jpg`,
    place: `${CDN}/onboarding_assets/visual_styles_examples/place_day_one.jpg`,
    service: `${CDN}/onboarding_assets/visual_styles_examples/service_day_one.jpg`,
  },
  'cyan crisp': {
    product: `${CDN}/onboarding_assets/visual_styles_examples/product_cyan_crisp.jpg`,
    place: `${CDN}/onboarding_assets/visual_styles_examples/place_cyan_crisp.jpg`,
    service: `${CDN}/onboarding_assets/visual_styles_examples/service_cyan_crisp.jpg`,
  },
  'deep contrast': {
    product: `${CDN}/onboarding_assets/visual_styles_examples/product_deep_contrast.jpg`,
    place: `${CDN}/onboarding_assets/visual_styles_examples/place_deep_contrast.jpg`,
    service: `${CDN}/onboarding_assets/visual_styles_examples/service_deep_contrast.jpg`,
  },
  'dramatic luxe': {
    product: `${CDN}/onboarding_assets/visual_styles_examples/product_dramatic_luxe.jpg`,
    place: `${CDN}/onboarding_assets/visual_styles_examples/place_dramatic_luxe.jpg`,
    service: `${CDN}/onboarding_assets/visual_styles_examples/service_dramatic_luxe.jpg`,
  },
  'gauzy portrait': {
    product: `${CDN}/onboarding_assets/visual_styles_examples/product_gauzy_portrait.jpg`,
    place: `${CDN}/onboarding_assets/visual_styles_examples/place_gauzy_portrait.jpg`,
    service: `${CDN}/onboarding_assets/visual_styles_examples/service_gauzy_portrait.jpg`,
  },
}

export function getBeforeImage(businessType?: BusinessType | null): string {
  return (businessType && BEFORE_IMAGES[businessType]) ?? FALLBACK_BEFORE
}

export function getAfterImage(styleName: string, businessType?: BusinessType | null): string | undefined {
  return businessType ? AFTER_IMAGES[styleName.toLowerCase().trim()]?.[businessType] : undefined
}
